export const ccaRateChartTypeOptions = [
  {
    id: "cost_per_trip_and_student_type",
    name: "Cost Per Trip Based On Student Type",
  },
  { id: "cost_per_trip_based_on_area", name: "Cost Per Trip Based On Area" },
  { id: "cost_per_week", name: "Cost Per Week" },
  { id: "no_cost_calculation", name: "No Cost Calculation" },
];

export enum ccaRateChartType {
  costPerTripAndStudentType = "cost_per_trip_and_student_type",
  costPerTripBasedOnArea = "cost_per_trip_based_on_area",
  costPerWeek = "cost_per_week",
  noCost = "no_cost_calculation",
};
